import './Header.scss';

import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { type RefineThemedLayoutHeaderProps } from '@refinedev/antd';
import { Button, Flex, Layout as AntdLayout, Switch } from 'antd';
import React, { useContext } from 'react';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import { ColorModeContext } from '@/contexts/ColorModeContext';
import { useUiContext } from '@/contexts/UiContext';
import { useUserContext } from '@/contexts/UserContext';
import { UserWorkAreaString } from '@/model/General/UserWorkArea';

import HeaderNotifications from './HeaderNotifications';
import LanguageSelector from './LanguageSelector';
import UserMenuIcon from './UserMenuIcon';

const Header: React.FC<RefineThemedLayoutHeaderProps> = () => {
  const { openSider, setOpenSider, isMediumScreen, isMobile } = useUiContext();
  const { userLogged, devOptions } = useUserContext();
  const { mode, setMode } = useContext(ColorModeContext);

  return (
    <AntdLayout.Header className="LayoutHeader">
      {isMediumScreen && (
        <div className="LayoutHeaderMobileTrigger">
          <Button
            className="LayoutHeaderMobileTriggerButton"
            type="text"
            icon={openSider ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setOpenSider(!openSider)}
          />
        </div>
      )}
      <Flex gap={16} align="center" justify="end">
        {!isMobile && devOptions && (
          <AntdSelect
            size="small"
            value={devOptions.selectedWorkArea}
            onChange={devOptions.handleChangeWorkArea}
            options={Object.keys(UserWorkAreaString).map(v => ({
              label: UserWorkAreaString[v as keyof typeof UserWorkAreaString],
              value: v,
            }))}
          />
        )}
        <LanguageSelector />
        <Switch
          checkedChildren="🌛"
          unCheckedChildren="🔆"
          onChange={() => setMode(mode === 'light' ? 'dark' : 'light')}
          defaultChecked={mode === 'dark'}
        />
        <HeaderNotifications />
        <UserMenuIcon user={userLogged} />
      </Flex>
    </AntdLayout.Header>
  );
};

export default Header;
